import { PageTab } from '../../../../types/graphql'

export const getPanelIdForPageTab = (tab: PageTab) => `PagePanel__${tab.id}`

export const getTabIdForPageTab = (tab: PageTab) => `PageTab__${tab.id}`
